"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTrusted = void 0;
const asyncConnection_1 = require("../../../features/authoriser/helpers/asyncConnection");
class BaseTrusted {
    constructor(api, data, session, urlConfig) {
        this.asyncConnection = undefined;
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
        this.session = session;
        this.urlConfig = urlConfig;
    }
    init(authoriserInstance) {
        return __awaiter(this, void 0, void 0, function* () {
            this.asyncConnection = yield (0, asyncConnection_1.openAsyncConnection)(authoriserInstance.asyncConnectionMode, this.api, this.session, authoriserInstance.progressId, authoriserInstance.accessToken, this.data, (value) => authoriserInstance.verifyChallenge(value), this.urlConfig);
        });
    }
    closeAsyncConnection() {
        var _a;
        (_a = this.asyncConnection) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.asyncConnection = undefined;
    }
    finish() {
        this.closeAsyncConnection();
    }
}
exports.BaseTrusted = BaseTrusted;
//# sourceMappingURL=baseTrusted.js.map